<template>
  <div class="home-wrapper">
    <div v-if="!showForgotPasswordScreen" class="home-background-container">
      <img class="home-background-image" src="/img/home_background.jpg" />
    </div>
    <div v-if="!showForgotPasswordScreen" class="right-side-container">
      <div class="top-logo">
        <img class="logo-img" src="/img/joule-logo.png" />
        <div class="greeting">Bem vindo!</div>
      </div>
      <span class="collaborator-title">
        Área do Colaborador
      </span>
      <div class="login-form-wrapper">
        <form action="submit">
          <div class="inputs-wrapper">
            <input
              placeholder="Email"
              id="email"
              class="form-input margin-input-email"
              type="email"
              v-model="email"
            />
            <input
              type="password"
              placeholder="Senha"
              id="password"
              class="form-input"
              v-model="password"
            />
          </div>

          <button
            class="login-button"
            @click.prevent
            @click="submit"
            type="submit"
          >
            Login
          </button>
        </form>
        <div
          @click.prevent
          @click="toggleForgotPassword"
          class="forgot-password"
        >
          <span>Esqueci minha senha</span>
        </div>
      </div>
      <div
        class="form-footer d-flex flex-column align-items-center text-center"
      >
        <div>
          <a
            target="_blank"
            class="mr-2"
            href="https://instagram.com/jouleenergiasolar?igshid=rl8j035gycbe"
            ><i
              class="fa fa-instagram instagram-icon mr-1 insta-icon"
              aria-hidden="true"
            ></i>
            <span>@jouleenergiasolar</span></a
          >
          <a
            target="_blank"
            class="mr-2"
            href="https://instagram.com/joule_homologacao?igshid=YmMyMTA2M2Y="
            ><i
              class="fa fa-instagram instagram-icon mr-1 insta-icon"
              aria-hidden="true"
            ></i>
            <span>@joule_homologação</span></a
          >
        </div>
        <div class="address-section">
          <span
            >Rua Jornalista José Ramalho, 33, Costa e Silva, João Pessoa - PB,
            58081-110</span
          >
        </div>
      </div>
    </div>
    <div v-if="showForgotPasswordScreen" class="forgot-password-container">
      <div>
        <span class="collaborator-title">
          Recupere sua senha
        </span>
        <input
          placeholder="Email"
          id="emailForgotPassword"
          class="form-input margin-input-email-forgot-password"
          type="email"
          v-model="emailForgotPassword"
        />

        <button
          class="login-button"
          @click.prevent
          @click="submitForgotPassword"
          type="submit"
        >
          Enviar
        </button>
        <div
          @click.prevent
          @click="toggleForgotPassword"
          class="forgot-password"
        >
          <span>Voltar</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue';
import { validateEmail } from 'src/utils';
import UserServices from 'src/services/usuarios';
import {
  showErrorMessage,
  getErrorMessageFromResponse
} from 'src/utils/notify';
import { startLoading } from 'src/utils/loading';
import _ from 'lodash';

export default {
  components: {
    Card
  },
  data() {
    return {
      email: '',
      password: '',
      showForgotPasswordScreen: false,
      emailForgotPassword: ''
    };
  },
  created() {},
  updated() {},
  methods: {
    toggleForgotPassword() {
      this.showForgotPasswordScreen = !this.showForgotPasswordScreen;
    },
    submitForgotPassword() {
      if (!validateEmail(this.emailForgotPassword)) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Digite um e-mail válido',
          'fa fa-exclamation-triangle'
        );
        return;
      }
      const loader = this.$loading.show({
        color: '#049F0C'
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Senha resetada. Verifique seu email',
          'fa fa-check'
        );
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      UserServices.resetarSenha(this.emailForgotPassword)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    submit() {
      if (!validateEmail(this.email)) {
        showErrorMessage(this, 'Digite um e-mail válido');
        return;
      }

      const loader = startLoading(this);

      UserServices.login(this.email, this.password)
        .then(response => {
          this.saveUser(response);

          const tipoUsuario = _.get(response, 'data.tipoUsuario').toLowerCase();
          const initialRouter = this.getInitialRouterByTipoUsuario(tipoUsuario);

          this.$router.replace(initialRouter);
        })
        .catch(err => {
          const errorMessage = getErrorMessageFromResponse(err);
          showErrorMessage(this, errorMessage);
        })
        .finally(() => {
          loader.hide();
        });
    },
    saveUser(response) {
      this.$store.commit('SAVE_USUARIO', _.get(response, 'data'));
      localStorage.setItem('userData', JSON.stringify(_.get(response, 'data')));
    },
    getInitialRouterByTipoUsuario(tipoUsuario) {
      switch (tipoUsuario) {
        case 'colaborador':
        case 'administrador':
          return 'controle-usuarios';

        case 'parceiro':
          return 'produtos';

        case 'vendedor':
        default:
          return 'perfil';
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: right;
  background-color: #fafafa;
}

.forgot-password-container {
  height: 100vh;
  width: 100vw;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.forgot-password-container > div {
  width: 100%;
  max-width: 27em;
  padding: 2em;
}

.inputs-wrapper {
  margin-bottom: 1.5em;
  padding-bottom: 12px;
  border-bottom: 0.5px solid #707070;
}

.login-button {
  font-family: Merriweather Sans;
  font-size: 20px;

  width: 100%;
  height: 2.5em;

  background-color: #ffcd00;
  border-radius: 8px;

  outline: none;
  border: none;

  color: #1c1c1c;
}

.login-button:hover {
  background-color: #fcc300;
}

.login-button:active {
  background-color: #fcc300;
  opacity: 0.8;
}

.home-background-container {
  height: 100vh;
  width: 65vw;
}
.home-background-container > img {
  height: 100%;
  object-fit: cover;
}

.home-background-image {
  width: 100vw;
  height: -webkit-fill-available;
}

.form-input {
  font-family: Merriweather Sans;

  width: 100%;
  height: 2.5em;

  background: #ffffff 0% 0% no-repeat padding-box;

  outline: none;
  border: none;

  border-radius: 8px;

  line-height: none;
  padding: 0.5em;
  color: #1c1c1c;
  font-size: 1.2em;
}

.form-input::placeholder {
  font-family: Merriweather Sans;
  font-size: 1em;
  color: #c1c1c1;
  font-weight: 300;
  padding-right: 0.5em;
}

.margin-input-email {
  margin-bottom: 0.75em;
}

.margin-input-email-forgot-password {
  margin-bottom: 1em;
  margin-top: 1em;
}

.right-side-container {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  height: -webkit-fill-available;
  width: 35vw;
  align-items: center;
  padding-top: 15vh;
  justify-content: space-evenly;
}

.top-logo {
  width: 7em;
  height: fit-content;
  margin-bottom: 10vh;
}

.logo-img {
  width: 100%;
  padding: 0.4em;
}

.greeting {
  font-family: Merriweather Sans;
  color: #707070;
  white-space: nowrap;
  padding: 0.2em;
  border-top: 1px solid #c8c8c8;
  font-weight: 600;
  display: flex;
  justify-content: center;
  font-size: 1.2em;
}

.login-form-wrapper {
  max-width: 22em;
  height: 30vh;
  margin-right: 1em;
  margin-left: 1em;
}

.collaborator-title {
  display: flex;
  font-family: Merriweather Sans;
  justify-content: center;

  color: #1c1c1c;
  font-size: 2em;
  text-align: center;
}

.forgot-password {
  display: flex;
  margin-top: 0.8em;

  width: 100%;

  justify-content: flex-end;
}

.forgot-password span {
  font-family: Merriweather Sans;
  font-size: 13px;
  color: #707070;
  cursor: pointer;
}

.forgot-password span:hover {
  color: #c1c1c1;
}

.forgot-password span:active {
  opacity: 0.8;
}

.form-footer {
  margin-top: 7em;
  color: #707070;
  display: flex;
  font-size: 0.8em;
}

.form-footer a {
  color: #707070;
}

.form-footer a:active {
  opacity: 0.8;
}
.form-footer a:hover {
  opacity: 0.9;
}

.instagram-icon {
  height: 1.1em;
  width: 1.1em;
}

.address-section {
  margin-top: 0.5em;
}

.insta-icon {
  font-size: 1.3em;
}

@media (max-width: 1000px) {
  .home-background-container {
    display: none;
  }

  .right-side-container {
    width: 100vw;
    justify-content: flex-start;
  }

  .top-logo {
    margin-top: 4vh;
  }

  .collaborator-title {
    font-size: 1.5em;
  }
}

@media (max-width: 600px) {
  .collaborator-title {
    font-size: 1.5em;
    padding-bottom: 1em;
  }

  .top-logo {
    margin-bottom: 8vh;
  }
}

@media (max-height: 600px) {
  .image-align {
    margin-top: -33% !important;
    transform: scale(0.8);
  }
}

@media (min-width: 400px) {
  .image-align {
    transform: scale(0.8) !important;
  }
}
</style>
